import styled from "styled-components";

export const AuthWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #fcfdfe;
  padding: 20px;
`;

export const AuthContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 488px;
`;

export const AuthLogoSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 24px;
`;

export const CompanyName = styled.h1`
  color: var(--GREY, #4a4a68);
  text-align: center;
  font-feature-settings:
    "liga" off,
    "clig" off;
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  margin: 0;
  margin-top: 20px;
`;

export const PortalSubtitle = styled.p`
  color: var(--GREY, #4a4a68);
  text-align: center;
  font-feature-settings:
    "liga" off,
    "clig" off;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin: 0;
  margin-top: 16px;
`;

export const FormCard = styled.div`
  border-radius: 4px;
  border: 1px solid #ecf1f4;
  background: #fff;
  padding: 40px 48px;
  width: 100%;
`;

export const FormTitle = styled.h2`
  color: var(--Dark, #1e1e2d);
  font-feature-settings:
    "liga" off,
    "clig" off;
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  margin: 0 0 24px 0;
`;

export const FormSubtitle = styled.p`
  color: var(--GREY, #4a4a68);
  font-feature-settings:
    "liga" off,
    "clig" off;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin: 0 0 24px 0;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const BackLink = styled.button`
  background: none;
  border: none;
  color: var(--DARK-BLUE, #1249bf);
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
  text-align: center;
  width: 100%;

  &:hover {
    text-decoration: underline;
  }
`;

export const ErrorMessage = styled.p`
  color: #e74c3c;
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin: 12px 0 0 0;
`;

export const PoweredBy = styled.p`
  color: var(--GREY, #4a4a68);
  text-align: center;
  font-feature-settings:
    "liga" off,
    "clig" off;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin: 0;
  margin-top: 32px;
`;

export const PoweredByBold = styled.span`
  color: var(--GREY, #4a4a68);
  font-feature-settings:
    "liga" off,
    "clig" off;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
`;
